jQuery($ => {
  // TinyMCE Images
	// Adjust parent style
	if ($('img.alignnone').length || $('img.alignleft').length || $('img.alignright').length || $('img.aligncenter').length) {
		$('img.alignnone, img.alignleft, img.alignright, img.aligncenter').parent('p').css({'margin-bottom': 0});
	}
});